/**
 * Register event listeners
 *
 * The listeners in this file are bound to the elements themselves rather than
 * delegated, because a document or body level handler sees the same click
 * through every matching ancestor and would fire the events twice.
 *
 * That makes them vulnerable to client-side re-renders: blocks running on the
 * Interactivity API (Product Collection pagination, Product Filters, the Mini
 * Cart) replace whole regions of the page, and the replacement elements would
 * carry no handlers. pmw.bindAndRebind therefore binds now and re-binds after
 * every DOM change, skipping elements that are already bound (see
 * interactivity-dom.js).
 */


/**
 * add_to_cart event
 *
 * WC is inconsistent with events that emit add-to-cart events.
 * adding_to_cart and added_to_are legacy events. Also, they only work
 * on Ajax buttons on shop pages.
 *
 * Never add document or body selectors.
 * The document selector doesn't work.
 * The body selector will cause the events to fire twice and other erratic behavior if used along with other selectors.
 *
 * The blockified product button keeps the add_to_cart_button and
 * ajax_add_to_cart classes and the data-product_id attribute, so it is matched
 * by the same selectors as the classic button.
 */
const addToCartSelectorsArray = [
	// "document",
	// "body",
	".add_to_cart_button:not(.product_type_variable)",
	".ajax_add_to_cart",
	".single_add_to_cart_button",
];

const addToCartSelectors = pmw.prepareSelectors(addToCartSelectorsArray, "addToCart");

pmw.bindAndRebind("addToCart", addToCartSelectors, "click adding_to_cart", (event, data) => {

	// console.log("add_to_cart event fired at: " + new Date().getTime())
	// console.log('add to cart data', data)
	// console.log('add to cart event', event)
	// console.log('add to cart jQuery(event.target.dataset)', jQuery(event.target.dataset))
	// console.log("add to cart event.target.dataset", event.target.dataset)
	// console.log("add to cart event.target.dataset.quantity", event.target.dataset.quantity)
	// console.log("add to cart event.target.dataset.product_id", event.target.dataset.product_id)

	try {

		// console.log("add_to_cart event detected")

		let quantity  = event?.target?.dataset?.quantity ? event.target.dataset.quantity : null;
		let productId = event?.target?.dataset?.product_id ? event.target.dataset.product_id : event?.target?.value ? event.target.value : null;

		// let quantity  = event.target.dataset.quantity ? event.target.dataset.quantity : 1
		// let productId = event.target.dataset.product_id ? event.target.dataset.product_id : null

		// Only process on product pages
		if (pmwDataLayer.shop.page_type === "product") {

			// First process related and upsell products
			if (
				typeof jQuery(event.currentTarget).attr("href") !== "undefined"
				&& jQuery(event.currentTarget).attr("href").includes("add-to-cart")
			) {

				if (!productId) {
					productId = jQuery(event.currentTarget).data("product_id");
				}

				pmw.addProductToCart(productId, 1);
				return;
			}

			// If is simple product
			if (pmwDataLayer.shop.product_type === "simple") {

				if (quantity === null) {
					quantity = Number(jQuery(".input-text.qty").val()) ? Number(jQuery(".input-text.qty").val()) : 1;
				}

				if (!productId) {
					productId = jQuery(event.currentTarget).val();
				}

				// Fallback if the body selector is used
				if (!productId) {
					// get the product ID from the element that has the class .product
					// that element will also have an ID that start with product- and ends with the product ID
					// example: product-123
					// save the product ID in the variable productId
					productId = jQuery(".product").attr("id").replace("product-", "");
				}

				pmw.addProductToCart(productId, quantity);
				return;
			}

			// If is variable product or variable-subscription
			if (["variable", "variable-subscription"].indexOf(pmwDataLayer.shop.product_type) >= 0) {

				if (quantity === null) {
					quantity = Number(jQuery(".input-text.qty").val()) ? Number(jQuery(".input-text.qty").val()) : 1;
				}

				if (!productId) {
					productId = jQuery("[name='variation_id']").val();
				}

				pmw.addProductToCart(productId, quantity);
				return;
			}

			// If is grouped product
			if (pmwDataLayer.shop.product_type === "grouped") {

				jQuery(".woocommerce-grouped-product-list-item").each((index, element) => {

					// Can't rely on  event.target.dataset as it always is sent with the parent product ID and the quantity 1

					quantity = Number(jQuery(element).find(".input-text.qty").val()) ? Number(jQuery(element).find(".input-text.qty").val()) : 1;

					let classes = jQuery(element).attr("class");
					productId   = pmw.getPostIdFromString(classes);

					pmw.addProductToCart(productId, quantity);
				});
				return;
			}

			// If is a container product (Product Bundles, Composite Products)
			if (["bundle", "composite"].indexOf(pmwDataLayer.shop.product_type) >= 0) {

				if (quantity === null) {
					// A container page carries one qty input per child item (named
					// bundle_quantity_<id> for bundles, wccp_component_quantity[<id>]
					// for composites) plus the container's own input, which is the only
					// one named "quantity". An unscoped .input-text.qty lookup matches a
					// child item's qty first, so scope to the container's own.
					let containerQty = Number(jQuery(event.currentTarget).closest("form.cart").find("input.qty[name='quantity']").val());
					quantity         = containerQty ? containerQty : 1;
				}

				if (!productId) {
					productId = jQuery("input[name=add-to-cart]").val();
				}

				pmw.addProductToCart(productId, quantity);
				return;
			}

			// everything else
			if (quantity === null) {
				quantity = Number(jQuery(".input-text.qty").val()) ? Number(jQuery(".input-text.qty").val()) : 1;
			}

			pmw.addProductToCart(productId, quantity);

		} else {

			/**
			 * Non-product pages can still contain a full single-product add-to-cart
			 * form, e.g. when rendered through the [product_page] shortcode or a page
			 * builder's single-product widget. There page_type is not "product", so we
			 * resolve the ids from the clicked button's enclosing form.cart.
			 *
			 * WooCommerce keeps the chosen variation in a hidden input[name='variation_id']
			 * and the parent product id in input[name='add-to-cart'], neither of which is
			 * exposed on a variable product's button, which is why such products were not
			 * tracked here before. Simple products keep working through the button value.
			 *
			 * Scoping the lookup to the clicked button's form also keeps things correct
			 * when several [product_page] embeds share the same page.
			 */
			const $form = jQuery(event.currentTarget).closest("form.cart");

			if (!productId && $form.length) {
				const variationId = $form.find("input[name='variation_id']").val();

				productId = (variationId && variationId !== "0")
					? variationId
					: $form.find("input[name='add-to-cart']").val() || null;
			}

			if (!productId) {
				// console.log("add to cart event.currentTarget", event.currentTarget)
				productId = jQuery(event.currentTarget).data("product_id") ? jQuery(event.currentTarget).data("product_id") : null;
			}

			// Another fallback to retrieve the product ID in case the ID is saved in the value attribute
			if (!productId) {
				productId = jQuery(event.currentTarget).val() ? jQuery(event.currentTarget).val() : null;
			}

			if (quantity === null) {
				quantity = ($form.length && Number($form.find("input.qty").val()))
					? Number($form.find("input.qty").val())
					: 1;
			}

			if (
				productId
				&& quantity
			) {
				pmw.addProductToCart(productId, quantity);
			}
		}

	} catch (e) {
		console.error(e);
	}
});


/**
 * If someone clicks anywhere on a custom /?add-to-cart=123 link
 * trigger the add to cart event
 */

// jQuery(document).one("click", "a:not(.add_to_cart_button, .ajax_add_to_cart, .single_add_to_cart_button)", (event) => {
pmw.bindAndRebind("addToCartLink", "a:not(.add_to_cart_button, .ajax_add_to_cart, .single_add_to_cart_button)", "click", (event) => {

	try {
		if (jQuery(event.target).closest("a").attr("href")) {

			let url = new URL(jQuery(event.currentTarget).attr("href"), window.location.origin);

			if (url.searchParams.has("add-to-cart")) {

				let productId = url.searchParams.get("add-to-cart");
				let quantity  = url.searchParams.has("quantity") ? parseInt(url.searchParams.get("quantity"), 10) : 1;
				pmw.addProductToCart(productId, quantity);
			}
		}
	} catch (e) {
		console.error(e);
	}
}, {once: true});

// select item event
// jQuery(document).on("click", ".woocommerce-LoopProduct-link, .wc-block-grid__product, .product, .product-small, .type-product", (event) => {
pmw.bindAndRebind("selectItem", ".woocommerce-LoopProduct-link, .wc-block-grid__product, .product, .product-small, .type-product", "click", (event) => {

	try {

		/**
		 * On some pages the event fires multiple times, and on product pages
		 * even on page load. Using e.stopPropagation helps to prevent this,
		 * but I don't know why. We don't even have to use this, since only a real
		 * product click yields a valid productId. So we filter the invalid click
		 * events out later down in the code. I'll keep it that way because this is
		 * the most compatible way across shops.
		 *
		 * e.stopPropagation();
		 * */

		let productId = jQuery(event.currentTarget).nextAll(".pmwProductId:first").data("id");

		/**
		 * Product Collection wraps each product in an <li> that carries the
		 * marker as a child rather than as a following sibling, because the
		 * block renders no loop item link the marker could follow. Reading it
		 * from inside the clicked element is scoped to the block's own item key
		 * on purpose: an unscoped lookup inside the element would also resolve
		 * the main product on a product page, where this handler fires on page
		 * load, and report a select_item nobody triggered.
		 */
		if (!productId && jQuery(event.currentTarget).is("[data-wp-key^='product-item-']")) {
			productId = jQuery(event.currentTarget).find(".pmwProductId:first").data("id");
		}

		/**
		 * On product pages, for some reason, the click event is triggered on the main product on page load.
		 * In that case no ID is found. But we can discard it, since we only want to trigger the event on
		 * related products, which are found below.
		 */

		if (productId) {

			productId = pmw.getIdBasedOndVariationsOutputSetting(productId);

			if (!productId) throw Error("Wasn't able to retrieve a productId");

			if (pmwDataLayer.products && pmwDataLayer.products[productId]) {

				let product = pmw.getProductDetailsFormattedForEvent(productId);

				pmw.bus.emit("pmw:select-item", product);
			}
		}
	} catch (e) {
		console.error(e);
	}
});


// checkout_progress event
// track checkout option event: entered valid billing email
// jQuery(document).on("input", "#billing_email", (event) => {
pmw.bindAndRebind("billingEmail", "#billing_email", "input", (event) => {

	if (pmw.isEmail(jQuery(event.currentTarget).val())) {
		// pmw.fireCheckoutOption(2);
		pmw.fireCheckoutProgress(2);
		pmw.emailSelected = true;
	}
});


/**
 * Place order button
 *
 * Track checkout option event: purchase click
 * https://stackoverflow.com/a/34112407/4688612
 * jQuery(document).one("click", "#place_order", () => {
 *
 * Has to be hooked after document ready !
 */
pmw.bindAndRebind("placeOrderSuccess", "form.checkout", "checkout_place_order_success", () => {

	// console log current time
	// console.log("checkout_place_order_success event fired at: " + new Date().getTime())

	if (false === pmw.emailSelected) {
		pmw.fireCheckoutProgress(2);
	}

	if (false === pmw.paymentMethodSelected) {
		pmw.fireCheckoutProgress(3);
		pmw.fireCheckoutOption(3, jQuery("input[name='payment_method']:checked").val());
	}

	pmw.fireCheckoutProgress(4);

	pmw.bus.emit("pmw:place-order", {});
});

/**
 * Update cart event
 *
 * Has to be hooked after document ready !
 */
jQuery(document).on("click", "[name='update_cart']", () => {

	try {
		jQuery(".cart_item").each((index, element) => {

			const productId = pmw.getProductIdByCartItemElement(element);

			if (!productId) {
				console.error("Pixel Manager: Wasn't able to retrieve a productId");
				return;
			}

			const quantity = pmw.getProductQuantityByCartItemElement(element);

			if (!quantity) {
				console.error("Pixel Manager: Wasn't able to retrieve a quantity");
				return;
			}

			// console.log("productId", productId)
			// console.log("quantity", quantity)

			if (quantity === 0) {
				pmw.removeProductFromCart(productId);
			} else if (quantity < pmwDataLayer.cart[productId].quantity) {
				pmw.removeProductFromCart(productId, pmwDataLayer.cart[productId].quantity - quantity);
			} else if (quantity > pmwDataLayer.cart[productId].quantity) {
				pmw.addProductToCart(productId, quantity - pmwDataLayer.cart[productId].quantity);
			}
		});
	} catch (e) {
		console.error(e);
		pmw.getCartItemsFromBackend();
	}
});

// Supports the following plugins:
// WooCommerce Wishlist: https://woo.com/products/woocommerce-wishlists/
// YITH WooCommerce Wishlist: https://wordpress.org/plugins/yith-woocommerce-wishlist/
// add_to_wishlist
pmw.bindAndRebind("addToWishlist", ".add_to_wishlist,.wl-add-to", "click", event => {

	try {

		let productId;

		if (jQuery(event.currentTarget).data("productid")) { // for the WooCommerce wishlist plugin

			productId = jQuery(event.currentTarget).data("productid");
		} else if (jQuery(event.currentTarget).data("product-id")) {  // for the YITH wishlist plugin

			productId = jQuery(event.currentTarget).data("product-id");
		}

		if (!productId) throw Error("Wasn't able to retrieve a productId");

		let product = pmw.getProductDetailsFormattedForEvent(productId);


		pmw.bus.emit("pmw:add-to-wishlist", product);
	} catch (e) {
		console.error(e);
	}
});


/**
 * Called when the user selects all the required dropdowns / attributes
 *
 * Replaced by code in the event_listeners.js file in case of lazy loading
 *
 * Has to be hooked after document ready !
 *
 * https://stackoverflow.com/a/27849208/4688612
 * https://stackoverflow.com/a/65065335/4688612
 *
 */

if (!pmwDataLayer?.general?.lazy_load_pmw) {
	pmw.registerShowVariationEventListener();
}


/**
 * Called on variable products when no selection has been done yet
 * or when the visitor deselects his choice.
 *
 * Has to be hooked after document ready !
 */

// jQuery(function () {
//
// 	jQuery(".single_variation_wrap").on("hide_variation", function () {
//
// 		try {
// 			let classes   = jQuery("body").attr("class")
// 			let productId = classes.match(/(postid-)(\d+)/)[2]
//
// 			if (!productId) throw Error("Wasn't able to retrieve a productId")
//
// 			/**
// 			 * If we have a variable product with no preset,
// 			 * and variations output is enabled,
// 			 * then we send a viewItem event with the first
// 			 * variation we find for the parent.
// 			 * If variations output is disabled,
// 			 * we just send the parent ID.
// 			 *
// 			 * And if Facebook microdata is active, use the
// 			 * microdata product ID.
// 			 */
//
// 			if (
// 				"variable" === pmwDataLayer.shop.product_type &&
// 				pmwDataLayer?.shop?.variations_output
// 			) {
// 				for (const [key, product] of Object.entries(pmwDataLayer.products)) {
// 					if ("parent_id" in product) {
//
// 						productId = product.id
// 						break
// 					}
// 				}
//
// 				if (pmwDataLayer?.pixels?.facebook?.microdata_product_id) {
// 					productId = pmwDataLayer.pixels.facebook.microdata_product_id
// 				}
// 			}
//
// 			// console.log("hmm")
// 			pmw.triggerViewItemEventPrep(productId)
//
// 		} catch (e) {
// 			console.error(e)
// 		}
// 	})
// })

// jQuery(function () {
//
// 	jQuery(".single_variation_wrap").on("hide_variation", function () {
// 		pmw.bus.emit("pmw:view-item")
// 	})
// })
